import { Component, Input, OnChanges } from '@angular/core'
import { Router, UrlTree} from '@angular/router'
import { BaseComponent } from '../base.component'
import { Alert, CustomerState, Route } from '../../types'
import { Customer, Account, User } from '../../pages/dashboard-page/dashboard.queries'
import { noTopicsAlert, bpsPreferencesAlert, newProposedKeywordsAlert } from '../../logic/customer-alerts'
import { customerInContext } from '../../logic/customer-states'
import { environment } from '../../environments/environment'
import get from 'lodash-es/get'

@Component({
  selector: 'post-tabs',
  templateUrl: './post-tabs.component.html'
})
export class PostTabs extends BaseComponent implements OnChanges {
  @Input() customer: Customer
  @Input() account: Account
  @Input() currentUser: User
  demo: boolean = environment.demo
  activeRequests: number

  constructor(private router: Router) {
    super()
  }

  ngOnChanges(): void {
    this.activeRequests = this.customer?.activeKeywordsCount + this.customer?.assignedKeywordsCount + this.customer?.activeRequestsCount
  }

  postTabTitleFor(tabContext: string): string {
    if (tabContext === 'more') {
      if (this.isActive(this.tabRoute('business_info')))
        return 'Business Info'
      else if (this.isActive(this.tabRoute('plan')) || this.isActive(this.tabRoute('multipass-plan')))
        return 'Change Plan'
      else if (this.isActive(this.tabRoute('delivery_options')))
        return 'Delivery Options'
      else
        return 'More'
    }
  }

  urlTree(route: Array<any>): UrlTree {
    return route ? this.router.parseUrl(route.join('/')) : this.router.parseUrl('/')
  }

  // True if any of the routes passed are active
  active(routes: Route[]): boolean {
    for (let i = 0; i < routes.length; i++) {
      const route = routes[i]
      if (this.isActive(route)) return true
    }
    return false
  }

  isActive(route: Array<any>): boolean {
    return this.router.isActive(this.urlTree(route), false)
  }

  noTopicsAlert(): Alert {
    return this.customer && noTopicsAlert(this.customer)
  }

  bpsPreferencesAlert(): Alert {
    return this.customer && bpsPreferencesAlert(this.customer)
  }

  moreAlert(): Alert {
    return this.bpsPreferencesAlert()
  }

  newProposedKeywordsAlert(): Alert {
    return this.customer && newProposedKeywordsAlert(this.customer)
  }

  topicsDropdownAlert(): Alert {
    return this.newProposedKeywordsAlert()
  }

  customerInContext(context: CustomerState): boolean {
    if (this.customer) {
      return customerInContext(this.customer, context)
    } else {
      return false
    }
  }

  clearCustomer(): boolean {
    if (this.demo) {
      if (confirm('Are you sure you want to remove this subscription?')) {
        location.assign(`/customers/${this.customer.id}/clear`)
      }
    }
    return false
  }

  navigateToRoute(route: Route): void {
    this.router.navigate(route)
  }

  hasKeywordsDropdownToggleAlert(): boolean {
    const proposedTopicsRoute = this.tabRoute('proposed_topics')
    return (this.customer.proposedKeywordsCount > 0 && !this.isActive(proposedTopicsRoute)) ||
      (this.noTopicsAlert() && this.isActive(proposedTopicsRoute))
  }

  get video(): boolean {
    return <string>get(this.customer, ['subscription', 'plan', 'code']) === 'video'
  }

  get adminImpersonating(): boolean {
    return this.currentUser.adminImpersonating
  }

  topicIdeasMessage(): string {
    return this.customer.proposedKeywordsCount ?
      `You have ${this.customer.proposedKeywordsCount} proposed topics to consider.` :
      ''
  }

  activeRequestMessage(): string {
    if (this.activeRequests > 0 && this.customer?.subscription?.plan?.code != 'video') {
      return `You have ${this.activeRequests} active requests, asking for a total of ${this.customer.totalKeywordsPieces} pieces.`
    } else {
      return ''
    }
  }

  queueSubsMessage(): string {
    return this.customer.queuedPostsCount ?
      `You have ${this.customer.queuedPostsCount} queued submissions awaiting your decision.` :
      ''
  }

  tabRoute(tab: string): any {
    return ['/dashboard', this.customer.id, tab]
  }
}
